import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { LibraryFacade } from '../facades/library.facade';

export function libraryCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const libraryFacade = inject(LibraryFacade);
        libraryFacade.clear();

        return true;
    };
}
